import type { IdentityType } from "../../types/assessment/data/index.ts";

/** Mirrors `@p0security/integrations-gcloud-backend`'s own `DEFAULT_COMPUTE_SUFFIX`/
 * `MemberKey`/`Service`/`GcpResourceInfo`/`frnToInfo` (`shared/asset.ts`),
 * duplicated locally since `shared` cannot import an integration package.
 * Narrowed to the slice needed by `./presets/resource/gcp.ts` and
 * `./presets/grant/gcp.ts`. */
export const DEFAULT_COMPUTE_SUFFIX = "compute@developer.gserviceaccount.com";

export const MemberKey: Partial<Record<IdentityType, string>> = {
  federated: "user",
  "logged-in": "allAuthenticatedUsers",
  "service-account": "serviceAccount",
  domain: "domain",
  group: "group",
  public: "allUsers",
  user: "user",
};

export const Service = {
  compute: "compute",
  crm: "cloudresourcemanager",
  functions: "functions",
  iam: "iam",
  kms: "cloudkms",
  secretManager: "secretmanager",
  storage: "storage",
  run: "run",
};

export type GcpResourceInfo = {
  api: string;
  id: string | undefined;
  locator: string;
  service: string;
  type: string | undefined;
};

/** Converts a full resource name to a service, locator, asset type, and id
 *
 * E.g.
 *
 * ```
 *   "//cloudresourcemanager.googleapis.com/projects/foo" => {
 *     api: "cloudresourcemanager.googleapis.com",
 *     id: "foo",
 *     locator: "projects/foo",
 *     service: "cloudresourcemanager",
 *     type: "projects",
 *   }
 * ```
 */
export const frnToInfo = (frn: string): GcpResourceInfo => {
  const [_0, _1, api, ...locator] = frn.split("/");
  const [service] = api.split(".");
  return {
    api,
    id: locator.at(-1),
    locator: locator.join("/"),
    service,
    type: locator.at(-2),
  };
};
